export default "/assets/images/list-icon2.svg?29a20d23cc10ae5b073e050796eef44d";